import type { ReactNode } from 'react';

import { useNumberFormatter } from '@mint-lib/formatting-hooks';

export const FormattedNumberValue = ({
  value,
  renderValue,
}: {
  value: number;
  renderValue: (value: string) => ReactNode;
}) => {
  const { format } = useNumberFormatter();
  const formattedValue = format(value);
  const valueToRender =
    typeof formattedValue === 'string'
      ? formattedValue
      : (formattedValue?.formatted ?? '');

  return renderValue(valueToRender);
};
